import React from "react";

const FooterLogoSvg = () => (
  <svg className="w-7 h-7" viewBox="375 478 215 245">
    <defs>
      <linearGradient
        id="ftg1"
        gradientUnits="userSpaceOnUse"
        x1="393.67"
        y1="684.95"
        x2="533.85"
        y2="544.05"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="ftg2"
        gradientUnits="userSpaceOnUse"
        x1="440.92"
        y1="745.23"
        x2="552.7"
        y2="633.44"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="ftg3"
        gradientUnits="userSpaceOnUse"
        x1="422.41"
        y1="705.54"
        x2="515.05"
        y2="625.48"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="ftg4"
        gradientUnits="userSpaceOnUse"
        x1="523.51"
        y1="453.91"
        x2="392.39"
        y2="584.13"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF8F" />
      </linearGradient>
      <linearGradient
        id="ftg5"
        gradientUnits="userSpaceOnUse"
        x1="541.26"
        y1="501.88"
        x2="417.71"
        y2="676.55"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF8F" />
      </linearGradient>
      <linearGradient
        id="ftg6"
        gradientUnits="userSpaceOnUse"
        x1="543.31"
        y1="488.63"
        x2="455.67"
        y2="569.01"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF7B" />
      </linearGradient>
    </defs>
    <path
      fill="url(#ftg1)"
      d="M572.12,577.15L407.87,717.12l67.91-186.27h15.84c9.4,0,18.48,1.39,27.04,3.99C541.36,541.72,560.4,557.04,572.12,577.15z"
    />
    <path
      fill="url(#ftg2)"
      d="M584.74,623.98c0,0.28,0,0.56-0.01,0.83c-0.45,51.05-41.97,92.3-93.13,92.3h-83.74l164.25-139.97c0.97,1.66,1.89,3.35,2.76,5.08C581.19,594.79,584.74,608.97,584.74,623.98z"
    />
    <path
      fill="url(#ftg3)"
      d="M407.87,717.12c6.74-5.95,13.55-11.83,20.32-17.75l20.41-17.64c6.79-5.89,13.64-11.71,20.47-17.57l20.49-17.54l20.57-17.45c6.86-5.81,13.7-11.65,20.59-17.42l20.65-17.35c6.92-5.75,13.8-11.53,20.75-17.24c-6.74,5.95-13.54,11.83-20.31,17.75l-20.41,17.64c-6.79,5.9-13.65,11.71-20.47,17.57l-20.49,17.54l-20.57,17.45c-6.86,5.81-13.7,11.65-20.59,17.42l-20.65,17.35C421.7,705.62,414.81,711.4,407.87,717.12z"
    />
    <path
      fill="url(#ftg4)"
      d="M555.4,482.88L391.14,622.85c-0.97-1.66-1.89-3.35-2.76-5.08c-6.31-12.56-9.87-26.74-9.87-41.76c0-0.28,0-0.56,0.01-0.83c0.45-51.05,41.97-92.3,93.13-92.3H555.4z"
    />
    <path
      fill="url(#ftg5)"
      d="M555.4,482.88l-67.91,186.27h-15.84c-9.4,0-18.48-1.39-27.04-3.99c-22.72-6.88-41.75-22.2-53.48-42.31L555.4,482.88z"
    />
    <path
      fill="url(#ftg6)"
      d="M555.4,482.88c-6.74,5.95-13.55,11.83-20.32,17.75l-20.41,17.64c-6.79,5.89-13.64,11.71-20.47,17.57l-20.49,17.54l-20.57,17.45c-6.86,5.81-13.7,11.65-20.59,17.42l-20.66,17.35c-6.92,5.75-13.8,11.53-20.75,17.24c6.74-5.95,13.54-11.83,20.32-17.75l20.41-17.64c6.79-5.9,13.65-11.71,20.47-17.57l20.49-17.54l20.57-17.45c6.86-5.81,13.7-11.65,20.59-17.42l20.65-17.35C541.57,494.38,548.46,488.6,555.4,482.88z"
    />
  </svg>
);

function NewDashFooter() {
  return (
    <footer className="border-t border-[rgba(255,255,255,0.08)] bg-[rgba(3,0,33,0.6)] font-sans">
      <div className="max-w-[1200px] mx-auto px-6 pt-12 pb-6">
        {/* Top grid */}
        <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 pb-8 border-b border-[rgba(255,255,255,0.08)] max-md:grid-cols-2 max-md:gap-8 max-[480px]:grid-cols-1 max-[480px]:gap-7">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <a
              href="https://sponsa.app"
              className="flex items-center gap-[10px] no-underline"
            >
              <FooterLogoSvg />
              <span className="text-base font-bold text-white tracking-tight">
                SPONSA
              </span>
            </a>
            <p className="text-[13px] text-[rgba(255,255,255,0.4)] leading-relaxed">
              The world's first multi-goal tipping platform. Support your
              favorite creators by funding specific goals, not just general
              tips.
            </p>
            <div className="flex gap-2 mt-1">
              <a
                href="https://x.com/SPONSAOfficial"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-[10px] bg-[rgba(255,255,255,0.06)] flex items-center justify-content-center justify-center text-[rgba(255,255,255,0.4)] no-underline transition-all duration-200 hover:bg-[rgba(0,255,143,0.1)] hover:text-[#00FF8F]"
                aria-label="X/Twitter"
              >
                <svg
                  className="w-4 h-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div className="flex flex-col gap-1">
            <div className="text-xs font-bold text-white uppercase tracking-[0.06em] mb-2">
              Platform
            </div>
            <a
              href="https://sponsa.app/explore"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Explore Creators
            </a>
            <a
              href="https://sponsa.app/#home"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              How It Works
            </a>
          </div>

          {/* Creators */}
          <div className="flex flex-col gap-1">
            <div className="text-xs font-bold text-white uppercase tracking-[0.06em] mb-2">
              Creators
            </div>
            <a
              href="https://sponsa.app/insights/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Dashboard
            </a>
            <a
              href="https://help.sponsa.app/for-creators/4yqnnFziGPBYDwLaFWA41L/adding-goal-overlays-to-your-stream/6K6LWoLgsrs4WZuAgL7BK1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Goal Overlays
            </a>
            <a
              href="https://help.sponsa.app/for-creators/4yqnnFziGPBYDwLaFWA41L/adding-live-alerts-to-your-stream/6K6LWoLgssb4caNtsbMSbW"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Stream Alerts
            </a>
          </div>

          {/* Resources */}
          <div className="flex flex-col gap-1">
            <div className="text-xs font-bold text-white uppercase tracking-[0.06em] mb-2">
              Resources
            </div>
            <a
              href="https://help.sponsa.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Help Desk
            </a>
            <a
              href="mailto:hello@sponsa.app"
              className="text-[13px] text-[rgba(255,255,255,0.4)] no-underline py-1 transition-colors duration-150 hover:text-white"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex justify-between items-center pt-5 text-xs text-[rgba(255,255,255,0.4)] max-md:flex-col max-md:gap-3 max-md:text-center">
          <span>© 2026 SPONSA LTD. All rights reserved.</span>
          <div className="flex gap-5">
            <a
              href="https://sponsa.app/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[rgba(255,255,255,0.4)] no-underline hover:text-[rgba(255,255,255,0.6)]"
            >
              Terms of Service
            </a>
            <a
              href="https://sponsa.app/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[rgba(255,255,255,0.4)] no-underline hover:text-[rgba(255,255,255,0.6)]"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default NewDashFooter;
